const css = `
.m1 {
  padding: 15px !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075) !important;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  background-color: #fff !important;
  height: 60px;
  box-sizing:border-box;
}

.m1 .c1 {
  flex: 0 0 100%;
  max-width: 100%;
  display: flex !important;
  justify-content: center !important
}

.m1 .c1 img {
  vertical-align: middle;
  border-style: none
}

.m1 .c3 {
  position: absolute !important;
  top: 8px
}

.m1 p {
  margin-top: 0;
  margin-bottom: 0
}

.m1 a {
  color: #3490dc;
  text-decoration: none;
  background-color: transparent
}

.m1 .icon-back {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='12' height='20'%3E%3Cpath fill='%23555' stroke='transparent' stroke-width='0' style='' d='M 11.492,1.642 1.64,11.492 0,9.852 9.849,0 11.492,1.642 Z M 9.85,20 0,10.148 1.64,8.508 11.492,18.357 9.85,20 Z' /%3E%3C/svg%3E");
  background-repeat: no-repeat;
  display: inline-block;
  position: relative;
  width: 10px;
  height: 16px;
  background-size: 10px
}

.m1 .m1_c {
  position: relative !important;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto
}

@media (min-width: 576px) {
  .m1 .m1_c {
    max-width:540px
  }
}

@media (min-width: 768px) {
  .m1 .m1_c {
    max-width:720px
  }
}

@media (min-width: 992px) {
  .m1 .m1_c {
    max-width:960px
  }
}

@media (min-width: 1200px) {
  .m1 .m1_c {
    max-width:1140px
  }
}`;

export default css;
